<template>
  <router-view />
  <van-overlay :show="$store.state.loadingData?.status" z-index="99999">
    <div
      style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex-direction: column;
      "
    >
      <van-loading vertical>
        <template #icon>
          <van-icon name="star-o" size="30" />
        </template>
        加载中...
      </van-loading>
    </div>
  </van-overlay>
</template>
<style>
#app {
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
}

* {
  box-sizing: border-box;
}
html,
body {
  padding: 0;
  margin: 0;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}
</style>
